import React from 'react';
import { Icon } from 'react-fa';

const Loading = () =>(
  <div className="loading-container">
    <div className="loading"><Icon spin name="spinner" /></div>
  </div>);

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading.js